import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import MarkdownMessage from '@gluedigital/markdown-message'
import MapAssets from './MapAssets/MapAssets'
import TableAssets from './TableAssets/TableAssets'
import SearchInput from 'src/components/SearchInput/SearchInput'
import ToggleSwitch from 'src/components/ToggleSwitch/ToggleSwitch'
import { useFilteredAssets } from 'src/hooks/api'
import { useGeolocation } from 'src/hooks/geo'

import './Assets.sass'

const Assets = () => {
  const history = useHistory()
  const [filter, setFilter] = useState(history?.location?.state?.asset ?? '')
  const [onlyNearby, setOnlyNearby] = useState(false)
  const [map, setMap] = useState(!!history?.location?.state?.isMap)
  const loc = useGeolocation(onlyNearby)
  const filteredAssets = useFilteredAssets(filter, loc)

  const handleFilter = newFilter => {
    history.replace('/', { ...history?.location?.state, asset: newFilter })
    setFilter(history?.location?.state?.asset)
  }

  const handleMap = newValue => {
    history.replace('/', { ...history?.location?.state, isMap: newValue })
    setMap(newValue)
  }

  const mapText = <FormattedMessage id={`assets-home.map.${map ? 'true' : 'false'}`} />
  return (
    <div id="assets-home" className={`page-content-section ${map ? 'map-mode' : ''}`} >
      <header className="only-desktop">
        <h1>
          <MarkdownMessage id="assets-home.title" values={{ n: filteredAssets.length }} />
        </h1>
        <section>
          <div className="only-nearby only-desktop">
            Todos
            <ToggleSwitch value={onlyNearby} onChange={setOnlyNearby} />
            Zona
          </div>
          <button onClick={() => handleMap(!map)}>{mapText}</button>
        </section>
      </header>
      <div className="search-wrapper">
        <SearchInput value={filter} onChange={handleFilter} />
        <button className="only-mobile" onClick={() => handleMap(!map)}>{mapText}</button>
      </div>
      {map ? <MapAssets assets={filteredAssets} /> : <TableAssets assets={filteredAssets} />}
    </div>
  )
}

export default Assets
